import axios from 'axios';
import { getClerkTokenWithFallback } from './clerkTokenManager';

// Define the base URL for all API requests
// REACT_APP_API_URL can override for Container Apps migration
// In production, defaults to relative '/api' for SWA bundled functions
const API_BASE_URL = process.env.REACT_APP_API_URL 
  || (process.env.NODE_ENV === 'development'
      ? (window.location.hostname === '127.0.0.1'
          ? 'http://127.0.0.1:7072/api'
          : 'http://localhost:7072/api')
      : '/api');

// Create an axios instance with default configuration
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Add a request interceptor for authentication handling
api.interceptors.request.use(async (config) => {
  // Add Azure Function Key for production security
  if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_AZURE_FUNCTION_KEY) {
    config.params = {
      ...config.params,
      code: process.env.REACT_APP_AZURE_FUNCTION_KEY
    };
  }

  // Attach Clerk session token when available
  try {
    const token = await getClerkTokenWithFallback();
    
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`
      };
    } else {
      console.warn('[API] No Clerk token available for request');
    }
  } catch (tokenError) {
    console.error('[API] Error retrieving Clerk session token:', tokenError);
    // Don't throw - allow request to proceed without token
    // The backend will return 401 if auth is required
  }

  // Get Clerk user ID if available
  const clerkUser = localStorage.getItem('clerk-user');
  
  if (clerkUser) {
    try {
      const userData = JSON.parse(clerkUser);
      const userId = userData.id || userData.userId;
      
      // If method is GET or DELETE, add to params
      if (['get', 'delete'].includes(config.method)) {
        config.params = { 
          ...config.params, 
          userId 
        };
      } else {
        // For POST, PUT, etc., add to request body
        if (config.data && typeof config.data === 'object') {
          config.data = { 
            ...config.data, 
            userId 
          };
        } else if (!config.data) {
          config.data = { userId };
        }
      }
    } catch (error) {
      console.error('Error parsing Clerk user data:', error);
    }
  }
  
  return config;
}, error => {
  return Promise.reject(error);
});

// Export as both default and named export for compatibility
export default api;
export { api as apiClient };
